import { z } from 'zod';
import { optionnel } from '@shared/validation/helpers';
import { TRIMESTRE_RE } from '@shared/types/Dts';

export const DtsCreateSchema = z.object({
  trimestre: z.string().regex(TRIMESTRE_RE, 'Trimestre AAAA-T1 à AAAA-T4 requis'),
  notes: optionnel(z.string().max(500)),
});

export const DtsUpdateSchema = z.object({
  notes: optionnel(z.string().max(500)),
  reference_depot: optionnel(z.string().max(80)),
});

export type DtsCreateInput = z.infer<typeof DtsCreateSchema>;
export type DtsUpdateInput = z.infer<typeof DtsUpdateSchema>;
